export default "__VITE_ASSET__4dcfbf88__"